import { gql } from "@apollo/client";
import moment from "moment";

export const GET_CONDICIONES_CONTRATO_BY_PLAN = gql`
query condicionContratoByPlan($idEvaluacion: Int!, $idPlanCuidado: Int!) {
    condicionContratoByPlan(
        idEvaluacion: $idEvaluacion,
        idPlanCuidado: $idPlanCuidado
    ) {
        fechaDesde
        fechaHasta
        diasCorridosContrato
        diasTratamiento
        ivaPaciente
        condicionCliente
        condicionClienteDesc
        precioDiario
        observacion
        cotizado
        ajustePrestacion
        precioControl
        vigencia
        tipoPrecio
        condicional
        estadoPrecio{
            idAutorizacionControlEstado
        }
    }
}`;


export const adaptCondicionesContratoPlan = (data) => {
  return {
    fechaDesde: data?.condicionContratoByPlan?.fechaDesde,
    fechaHasta: data?.condicionContratoByPlan?.fechaHasta,
    diasCorridosContrato: data?.condicionContratoByPlan?.diasCorridosContrato,
    diasTratamiento: data?.condicionContratoByPlan?.diasTratamiento,
    ivaPaciente: data?.condicionContratoByPlan?.ivaPaciente,
    condicionCliente: data?.condicionContratoByPlan?.condicionCliente,
    condicionClienteDesc: data?.condicionContratoByPlan?.condicionClienteDesc,
    precioDiario: data?.condicionContratoByPlan?.precioDiario,
    estadoPrecio: data?.condicionContratoByPlan?.estadoPrecio?.idAutorizacionControlEstado,
    tipoPrecio: data?.condicionContratoByPlan?.tipoPrecio,
    vigencia: data?.condicionContratoByPlan?.vigencia,
    precioControl: data?.condicionContratoByPlan?.precioControl,
    observacion: data?.condicionContratoByPlan?.observacion,
    cotizado: data?.condicionContratoByPlan?.cotizado,
    ajustePrestacion: data?.condicionContratoByPlan?.ajustePrestacion,
    condicional: data?.condicionContratoByPlan?.condicional
  };
};